// @file Surface realtime store
import { getVuexStore } from '@@/bits/pinia'
import { useSurfaceStartingStateStore } from '@@/pinia/surface_starting_state'
import type { RootState } from '@@/vuexstore/surface/types'
import { defineStore } from 'pinia'

export const useRealtimeStore = defineStore('realtime', () => {
  const surfaceVuexStore = getVuexStore<RootState>()
  const surfaceStartingStateStore = useSurfaceStartingStateStore()

  // Actions
  const absent = (): void => {
    void surfaceVuexStore?.dispatch('realtime/absent', null, { root: true })
  }

  const present = (): void => {
    void surfaceVuexStore?.dispatch('realtime/present', null, { root: true })
  }

  const createNewBrahmsConnectionForUser = (): void => {
    void surfaceVuexStore?.dispatch('realtime/createNewBrahmsConnectionForUser', {
      userId: surfaceStartingStateStore.startingState.user.id,
      brahmsToken: surfaceStartingStateStore.startingState.brahmsToken,
    })
  }

  const disconnectBrahms = (): void => {
    void surfaceVuexStore?.dispatch('realtime/disconnectBrahms', null, { root: true })
  }

  return {
    // Actions
    absent,
    present,
    createNewBrahmsConnectionForUser,
    disconnectBrahms,
  }
})
